import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';

import {
    faFacebook,
    faLinkedin,
    faInstagram,
    faYoutube,
    faTwitter,
} from "@fortawesome/free-brands-svg-icons";
// import logo from "../Component/maamaaslog.png" // ✅ import your logo image

const Footer = () => {
    const [showLanguageModal, setShowLanguageModal] = useState(false);

    // Open Language Modal
    const handleLanguageClick = () => {
        setShowLanguageModal(true);
    };

    // Close Language Modal
    const handleCloseModal = () => {
        setShowLanguageModal(false);
    };

    return (
        <footer style={styles.footer}>
            <div className="container-fluid">
               
                <hr style={styles.line} />

                <div className="ffft" style={styles.subfooter}>
                    {/* Logo */}
                    <div className="" style={styles.logoTextContainer}>
                        <div style={styles.logoContainer}>
                            {/* <img src={logo} alt="Logo" style={styles.logo} /> */}
                        </div>

                        <p style={styles.logoText}></p>
                    </div>



                    {/* Center Text */}
                    <div style={styles.subfooterText}>
                        <p>
                            Copyright © 2025, All Rights Reserved To <strong>MAAMAAS</strong> {" "}
                            <strong></strong>

                            <a href="#" style={{ color: "orange" }}>
                                Terms of Use | Privacy Environmental Policy
                            </a>
                        </p>
                    </div>

                    {/* Language Button */}
                    {/* <div style={styles.languageContainer}>
            <button onClick={handleLanguageClick} style={styles.languageButton}>
              🌐
            </button>
          </div> */}
                </div>

                {/* Language Modal */}

            </div>
        </footer>
    );
};

const styles = {

    footer: {
        // backgroundColor: '#39164c',
        color: '#fff',
        padding: '20px 0',
        fontSize: '16px',
        fontFamily: "Roboto",
        fontWeight: '300',

    },
    socialIcons: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: '10px',
    },
    icon: {
        fontSize: '20px',
        color: '#fff',
        margin: '0 10px',
        cursor: 'pointer',
    },
    row: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        marginBottom: '20px',
    },
    column: {
        flex: '1',
        // margin: ' 5px',
        minWidth: '200px',
    },
    heading: {
        fontSize: '18px',
        fontWeight: '400',
        marginBottom: '10px',
        color: 'orange',
    },
    // line: {
    //     border: 'none',
    //     borderBottom: '1px solid orange',
    //     marginBottom: '0px',
    // },
    list: {
        listStyle: 'none',
        padding: 0,
        borderBottom: 'none',
    },
    listItem: {
        marginBottom: '5px',
    },
    subfooter: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: 'black',
         borderRadius:"5px",
        // padding: '10px 20px',
        color: 'white',
    },
    logoContainer: {
        flex: 1,
        textAlign: 'left',
    },
    logo: {
        height: '40px', // Adjust the height as needed
    },
    logoTextContainer: {
        display: 'flex',
        alignItems: 'center',
        textAlign: 'left',
    },
    subfooterText: {
        flex: 2,
        textAlign: 'center',
        fontFamily: 'sans,serif',

    },
    languageContainer: {
        // flex: 1,
        textAlign: 'right',
    },
    languageButton: {
        background: 'transparent',
        border: 'none',
        color: '#fff',
        cursor: 'pointer',
        fontSize: '30px',
        marginRight: '20px',
    },
};

const modalStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1000,
    },
    modal: {
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "20px",
        width: "300px",
        textAlign: "center",
    },
    title: {
        fontSize: "20px",
        marginBottom: "15px",
    },
    languageList: {
        listStyle: "none",
        padding: 0,
        margin: "10px 0",
    },
    languageItem: {
        margin: "5px 0",
        padding: "3px 10px",
        cursor: "pointer",
        borderRadius: "4px",
        backgroundColor: "#313840",
        textAlign: "center",
    },
    closeButton: {
        marginTop: "20px",
        padding: "10px 20px",
        backgroundColor: "#007BFF",
        color: "#fff",
        border: "none",
        cursor: "pointer",
        borderRadius: "4px",
    },
};

export default Footer;



